import React, { Component } from 'react';
import { Dialog, DialogHeader, DialogBody, DialogFooter } from '../../../../presentation/Dialog';

class UpdateFileDialog extends Component {
  onRenderHeader() {
    return (
      <DialogHeader caption={`Updating File`} closeButton onClose={this.props.onClose} />
    );
  }

  onRenderBody() {
    return (
      <DialogBody>
        <span className='file-management-merge-dialog-container'>
          <span>
            <label>Please provide a new filename/description.</label>
          </span>
          <span className='file-management-merge-dialog-item'>
            <label className='file-management-merge-dialog-item-label'>Filename</label>
            <input className='file-management-merge-dialog-item-input' type='text' name='updatedFilename' onChange={this.props.onInputChange} value={this.props.filename} />
          </span>
          <span className='file-management-merge-dialog-item'>
            <label className='file-management-merge-dialog-item-label'>Description</label>
            <input className='file-management-merge-dialog-item-input' type='text' name='updatedDescription' onChange={this.props.onInputChange} value={this.props.description} />
          </span>
        </span>
      </DialogBody>
    );
  }

  onRenderFooter() {
    return (
      <DialogFooter>
        <span className="asr-group-dialog-footer">
          <button className="asr-dialog-cancel-button" onClick={this.props.onClose}>Cancel</button>
          <button className="asr-dialog-save-button" onClick={this.props.onApply}>Apply</button>
        </span>
      </DialogFooter>
    );
  }

  render() {
    if ( this.props.show ) {
      return (
        <Dialog width={30} height={30} show={this.props.show} >
          {this.onRenderHeader()}
          {this.onRenderBody()}
          {this.onRenderFooter()}
        </Dialog>
      );
    } else {
      return null;
    }
  }
};

export default UpdateFileDialog;


// WEBPACK FOOTER //
// ./src/content/enterprise/filemanagement/components/UpdateFileDialog.js